<template>
  <footer class="grey darken-3" height="auto ma-0">
    <v-card flat tile class="grey darken-3 white--text text-xs-center">
      <v-container class="px-0">
            <v-card-text class="pt-0">
                <v-layout row wrap>
                    <v-flex xs12 sm4 md4 v-for="foot in footer" :key="foot.title">
                        <v-list class="transparent" subheader dense>
                            <v-subheader class="hero-text-f5 title">{{foot.title}}</v-subheader>
                            <template v-for="(item) in foot.items">
                                <template v-if="item.link">
                                    <v-list-tile :key="item.subtitle" router :to="item.link">
                                        <v-list-tile-content>
                                            <v-list-tile-title class="hero-text-f5" style="font-weight: 300;font-size: 15px">{{item.subtitle}}</v-list-tile-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </template>
                                <template v-else>
                                    <v-list-tile :key="item.subtitle" @click="item.action">
                                        <v-list-tile-content>
                                            <v-list-tile-title class="hero-text-f5" style="font-weight: 300;font-size: 15px"><v-icon color="white" class="mr-2" v-if="item.icon" size="20">{{item.icon}}</v-icon>{{item.subtitle}}</v-list-tile-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </template>
                            </template>
                        </v-list>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-container>
        <v-divider dark></v-divider>
        <v-card-text>
          <v-layout wrap row>
            <v-flex xs12 sm12 md3 class="title text-xs-center font-weight-bold py-3 hidden-sm-and-up">
              Follow us on:
            </v-flex>
            <v-spacer class="hidden-xs-only"></v-spacer>
            <v-flex v-for="(link, i) in social" :key="link.title" @click="open(link.link)" shrink class="pointer">
                <v-list-tile>
                    <v-list-tile-action style="min-width:35px">
                        <v-avatar size="20" :color=" i == 0 ? 'white' : ''" style="border-radius:5px" tile>
                            <img :src="link.icon">
                        </v-avatar>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title class="hero-text-f5 subheading">{{link.title}}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-flex>
            <v-spacer class="hidden-xs-only"></v-spacer>
          </v-layout>
        </v-card-text>

        <v-divider dark></v-divider>

      <v-card-text class="white--text text-uppercase">
        &copy;2020 — LOJ Student Service
      </v-card-text>
    </v-card>
  </footer>
</template>

<script>
export default {
    data() {
        return {
            footer: [
                {
                    title: "COMPANY",
                    items: [
                        {subtitle: "About us", link: "", action: () => {
                            this.$store.state.aboutDialog = true
                        }},
                        {subtitle: "Support@loj.com.com", link: "", action: () => {}, icon: 'mdi-mail'},
                        {subtitle: "+2349055841265", link: "", action: () => {document.location.href="tel:09055841265"}, icon: 'mdi-phone'},
                    ]
                },
                // {
                //     title: "USEFUL LINKS",
                //     items: [
                //         {subtitle: "Find Accomodation", link: "/lodges"},
                //         {subtitle: "Property Movers", link: "", action: () => {
                //             this.$store.state.movageDialog = true
                //         }},
                //         {subtitle: "How it works", link: "", action: () => {
                //             this.$store.state.howItWorks = true
                //         }},
                //     ]
                // },
                {
                    title: "Beta Version",
                    items: [
                        {subtitle: "Furnished Rooms", link: "", action: () => {}}
                    ]
                },
                {
                    title: "WEBSITE",
                    items: [
                        {subtitle: "Privacy Policy", link: "/policy"},
                        {subtitle: "Terms and Conditions", link: "/terms"},
                    ]
                }
            ],
            social: [
                {title: "Facebook", icon: "/assets/facebook.png", link: 'https://web.facebook.com/lojstudents'},
                {title: "Twitter", icon: "/assets/twitter.png", link: 'https://twitter.com/lojstudents'},
                {title: "Whatsapp", icon: "/assets/whatsapp.png", link: "https://wa.me/2349055841265?text=Good day, my name is "},
            ]
        }
    },
    methods: {
        open(link) {
            window.open(link, '_blank')
        }
    }
}
</script>
